import { createSelector } from 'reselect'

import { PostingRootState } from '../postingRoot.reducer'

export const getTags = createSelector(
  (state: PostingRootState) => state.postingStore.tags,
  (state) => state,
)

export const getDeferredPosts = createSelector(
  (state: PostingRootState) => state.postingStore.deferredPosts,
  (state) => state,
)

export const getAboTopics = createSelector(
  (state: PostingRootState) => state.postingStore.aboTopics,
  (state) => state,
)

export const getTemplates = createSelector(
  (state: PostingRootState) => state.postingStore.templates,
  (state) => state,
)

export const getMediaData = createSelector(
  (state: PostingRootState) => state.postingStore.mediaFiles,
  (state) => state,
)

export const getMediaFile = createSelector(
  (state: PostingRootState) => state.postingStore.mediaFile,
  (state) => state,
)

export const getTemporaryMediaFile = createSelector(
  (state: PostingRootState) => state.postingStore.temporaryMediaFile,
  (state) => state,
)

export const getUrlInformation = createSelector(
  (state: PostingRootState) => state.postingStore.pageResource,
  (state) => state,
)

export const isLoadingTMFile = createSelector(
  (state: PostingRootState) => state.postingStore.loadingTMFile,
  (state) => state,
)

export const getUpdatedPostTemplate = createSelector(
  (state: PostingRootState) => state.postingStore.updatedPostTemplate,
  (state) => state,
)

export const getUpdateTemplateId = createSelector(
  (state: PostingRootState) => state.postingStore.updateTemplateId,
  (state) => state,
)

export const getIndividualizedText = createSelector(
  (state: PostingRootState) => state.postingStore.individualizedText,
  (state) => state,
)

export const getSingleDeferredPost = createSelector(
  (state: PostingRootState) => state.postingStore.deferredPostById,
  (state) => state,
)
export const getPostingType = createSelector(
  (state: PostingRootState) => state.postingStore.postingType,
  (state) => state,
)

export const getPostingScreen = createSelector(
  (state: PostingRootState) => state.postingStore.postingScreen,
  (state) => state,
)


